import CAMPAIGN_MESSAGE_TYPES, { pushTypes } from "@lib/campaignMessageTypeConstants";

import type { ContentOptimizationChannel } from "./types";

const messageTypeToContentOptimizationChannel = new Map<string, ContentOptimizationChannel>([
  [CAMPAIGN_MESSAGE_TYPES.EMAIL, "email"],
  ...pushTypes.map((messageType) => [messageType, "push"] as const),
  ["push", "push"],
  [CAMPAIGN_MESSAGE_TYPES.SMS, "sms"],
]);

export const getChannelForMessageType = (
  messageType: string | null | undefined
): ContentOptimizationChannel | undefined => {
  if (messageType === null || messageType === undefined) {
    return undefined;
  }

  return messageTypeToContentOptimizationChannel.get(messageType);
};
